import React from "react";
import "./DoubleProgressBar.css";
import line from "@/assets/svg/Schoolreports/line.svg";

const DoubleProgressBar = ({ participation, average }) => {
  // Clean the percentage values
  const cleanPercentage = (value) => {
    if (typeof value === "string") {
      return parseFloat(value.replace("%", "")) || 0;
    }
    return value || 0;
  };

  const cleanParticipation = cleanPercentage(participation);
  const cleanAverage = cleanPercentage(average);

  // Calculate positions with boundary checks (5% buffer on each side)
  const topLabelPosition = Math.min(Math.max(cleanParticipation, 5), 95);
  const bottomLabelPosition = Math.min(Math.max(cleanAverage, 5), 95);

  return (
    <div className="SR_DP_container">
      <div className="SR_DP_bar_cont">
        <div
          className="SR_DP_blue_bar"
          style={{ width: `${cleanParticipation}%` }}
        >
          <img
            className="SR_IndexLine"
            alt="line"
            src={line}
            style={{ left: `${cleanParticipation}%` }}
          />
        </div>

        {/* <div className="SR_DP_yellow_bar" style={{ width: `${cleanAverage}%` }}>
          <img
            className="SR_IndexLine"
            alt="line"
            src={line}
            style={{ left: `${cleanAverage}%` }}
          />
        </div> */}
      </div>

      {/* Top Label */}
      <div
        className="SR_Label top-label"
        style={{
          left: `${topLabelPosition}%`,
          transform: `translateX(-${topLabelPosition > 50 ? 85 : 15}%)`,
          top: "35px",
        }}
      >
        <h3>
          <div
            className="SB_buedot2"
            style={{ backgroundColor: "#3c8dcb" }}
          ></div>
          Total Participation
          <span style={{ fontWeight: "700", marginLeft: "4px" }}>
            {cleanParticipation.toFixed(2)}%
          </span>
        </h3>
      </div>

      {/* Bottom Label */}
      {/* <div
        className="SR_Label bottom-label"
        style={{
          left: `${bottomLabelPosition}%`,
          transform: `translateX(-${bottomLabelPosition > 50 ? 85 : 15}%)`,
          bottom: "40px",
        }}
      >
        <h3>
          <div
            className="SB_buedot2"
            style={{ backgroundColor: "#FBD323" }}
          ></div>
          Avg participation from other schools
          <span style={{ fontWeight: "700", marginLeft: "4px" }}>
            {cleanAverage.toFixed(2)}%
          </span>
        </h3>
      </div> */}
    </div>
  );
};
export default DoubleProgressBar;
